import Appdev from './assets/images/course_card_images/appdev-card-img.jpg';
import Webdev from './assets/images/course_card_images/webdev-card-img.jpg';
import Uiux from './assets/images/course_card_images/uiux-card-img.jpg';

export const StudentsData = [
   {
    id: 1,
    name: 'smith rans',
    course: 'Fundamentals of Web Development',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   },
   {
    id: 2,
    name: 'toms kid',
    course: 'App Development',
    level: 'intermidate',
    guardian: '+44345003939',
    school: 'Teeside Basic School Cardiff'
   },
   {
    id: 3,
    name: 'Tomide Williams',
    course: 'UI/UX Design Fundamentals',
    level: 'advance',
    guardian: '+343189239',
    school: 'Borison Jnr School Newtown'
   },
   {
    id: 4,
    name: 'Chuks Emeka',
    course: 'Fundamentals of Web Development',
    level: 'intermidate',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   },
   {
    id: 5,
    name: 'Adeolu Babs',
    course: 'UI/UX Design Fundamentals',
    level: 'beginner',
    guardian: '+918934339',
    school: 'Newton Scope College Yilloln'
   },
   {
    id: 6,
    name: 'Hans Daniel',
    course: 'Fundamentals of Web Development',
    level: 'advance',
    guardian: '+918920039',
    school: 'Johnson Bosco N/P School Utstonm'
   },
   {
    id: 7,
    name: 'Faith Adams',
    course: 'Fundamentals of Web Development',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   },
   {
    id: 8,
    name: 'smith rans',
    course: 'App Development',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Handscome College Georgia City'
   },
   {
    id: 9,
    name: 'Black Smith',
    course: 'UI/UX Design Fundamentals',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Jiks Stone College New York Town'
   },
   {
    id: 10,
    name: 'smith rans',
    course: 'Fundamentals of Web Development',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   },
   {
    id: 11,
    name: 'toms kid',
    course: 'App Development',
    level: 'intermidate',
    guardian: '+44345003939',
    school: 'Teeside Basic School Cardiff'
   },
   {
    id: 12,
    name: 'Tomide Williams',
    course: 'UI/UX Design Fundamentals',
    level: 'advance',
    guardian: '+343189239',
    school: 'Borison Jnr School Newtown'
   },
   {
    id: 13,
    name: 'Chuks Emeka',
    course: 'Fundamentals of Web Development',
    level: 'intermidate',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   },
   {
    id: 14,
    name: 'Adeolu Babs',
    course: 'UI/UX Design Fundamentals',
    level: 'beginner',
    guardian: '+918934339',
    school: 'Newton Scope College Yilloln'
   },
   {
    id: 15,
    name: 'Hans Daniel',
    course: 'Fundamentals of Web Development',
    level: 'advance',
    guardian: '+918920039',
    school: 'Johnson Bosco N/P School Utstonm'
   },
   {
    id: 16,
    name: 'Faith Adams',
    course: 'Fundamentals of Web Development',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   },
   {
    id: 17,
    name: 'smith rans',
    course: 'App Development',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Handscome College Georgia City'
   },
   {
    id: 18,
    name: 'Black Smith',
    course: 'UI/UX Design Fundamentals',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Jiks Stone College New York Town'
   },
   {
    id: 19,
    name: 'smith rans',
    course: 'Fundamentals of Web Development',
    level: 'beginner',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   },
   {
    id: 20,
    name: 'toms kid',
    course: 'App Development',
    level: 'intermidate',
    guardian: '+44345003939',
    school: 'Teeside Basic School Cardiff'
   },
   {
    id: 21,
    name: 'Tomide Williams',
    course: 'UI/UX Design Fundamentals',
    level: 'advance',
    guardian: '+343189239',
    school: 'Borison Jnr School Newtown'
   },
   {
    id: 22,
    name: 'Chuks Emeka',
    course: 'Fundamentals of Web Development',
    level: 'intermidate',
    guardian: '+918920039',
    school: 'Montessori College Hilton'
   }
   
]

export const CoursesData = [
    {
        id: 1,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 2,
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 89,
        level: "Beginner"
      },
      {
        id: 3,
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 91,
        level: "Advanced"
      },
      {
        id: 4,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 40,
        level: "Intermediate"
      },
      {
        id: 5,
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 53,
        level: "Intermediate"
      },
      {
        id: 6,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 23,
        level: "Intermediate"
      },
      {
        id: 7,
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 8,
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 9,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 10,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 11,
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 89,
        level: "Beginner"
      },
      {
        id: 12,
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 91,
        level: "Advanced"
      },
      {
        id: 13,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 40,
        level: "Intermediate"
      },
      {
        id: 14,
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 53,
        level: "Intermediate"
      },
      {
        id: 15,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 23,
        level: "Intermediate"
      },
      {
        id: 16,
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 17,
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 18,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 19,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 23,
        level: "Intermediate"
      },
      {
        id: 20,
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 21,
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      },
      {
        id: 22,
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate"
      }
]

export const Paydata = [
    {
        id: 1,
        student: "Malik Samuel",
        invoice: "Invoice #23874909",
        paymentDate: "4 JAN 2023",
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 2,
        student: "Agbo Samuel",
        invoice: "Invoice #234354909",
        paymentDate: "4 JAN 2023",
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 89,
        level: "Beginner",
        status: "Accepted"
      },
      {
        id: 3,
        student: "Vicky Micheal",
        invoice: "Invoice #23345909",
        paymentDate: "4 JAN 2023",
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 91,
        level: "Advanced",
        status: "Accepted"
      },
      {
        id: 4,
        student: "Richard Manny",
        invoice: "Invoice #7675909",
        paymentDate: "4 JAN 2023",
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 40,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 5,
        student: "Townhall Balablue",
        invoice: "Invoice #27676888",
        paymentDate: "4 JAN 2023",
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 53,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 6,
        student: "Vivian James",
        invoice: "Invoice #8897545",
        paymentDate: "4 JAN 2023",
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 23,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 7,
        student: "Peter Obi",
        invoice: "Invoice #56768909",
        paymentDate: "4 JAN 2023",
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 8,
        student: "Abubakar Adamu",
        invoice: "Invoice #0099743",
        paymentDate: "4 JAN 2023",
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 9,
        student: "Bola Shagaya",
        invoice: "Invoice #7884909",
        paymentDate: "4 JAN 2023",
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 10,
        student: "Malik Samuel",
        invoice: "Invoice #23874909",
        paymentDate: "4 JAN 2023",
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 50,
        level: "Intermediate",
        status: "Accepted"
      },
      {
        id: 11,
        student: "Agbo Samuel",
        invoice: "Invoice #234354909",
        paymentDate: "4 JAN 2023",
        title:  "App Development Fundamentals",
        img: Appdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 89,
        level: "Beginner",
        status: "Accepted"
      },
      {
        id: 12,
        student: "Vicky Micheal",
        invoice: "Invoice #23345909",
        paymentDate: "4 JAN 2023",
        title:  "Web Development Fundamentals",
        img: Webdev,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 91,
        level: "Advanced",
        status: "Accepted"
      },
      {
        id: 13,
        student: "Richard Manny",
        invoice: "Invoice #7675909",
        paymentDate: "4 JAN 2023",
        title:  "User Experience Design: Figma UI/UX Design",
        img: Uiux,
        dateCreated: "January 2022",
        timeCreated: "5:48pm",
        price: "$1010",
        duration: "6 weeks",
        modules: 40,
        level: "Intermediate",
        status: "Accepted"
      },
     
]
export const AssignmentData = [
  {
    id: 1,
    name : "Redesign your Favourite Application",
    submission : 200
  },
  {
    id: 2,
    name : "Wireframe your Favourite Application",
    submission : 200
  },
  {
    id: 3,
    name : "Do a research on design thinking",
    submission : 200
  },
  {
    id: 4,
    name : "Read up on ideation",
    submission : 200
  }
  ]